import fonts from 'styles/fonts';
import styled from '@emotion/styled';

const StyledMoreEpisodesText = styled('p')({
  fontSize: fonts.size['14'],
  padding: '0.1rem 2rem',
});

export default StyledMoreEpisodesText;
